import React from 'react';
import './Hero.css';

const Hero = () => {

    return (
        <div className="hero" id="hero">
            <div className="heading">
                <div className="heading__line-1">
                    <span>Luke Siverling</span>
                </div>
                <div className="heading__line-2">Engineer</div>
            </div>
        </div>
    );
}

export default Hero;